// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__VD4ur.styles_ocean-50__sdxbh {
  color: #e6f2ff;
}

.styles_color__VD4ur.styles_ocean-100__9SceT {
  color: #e6f2ff;
}

.styles_color__VD4ur.styles_ocean-200__5QgkQ {
  color: #b3daff;
}

.styles_color__VD4ur.styles_ocean-300__RuOh3 {
  color: #7abfff;
}

.styles_color__VD4ur.styles_ocean-400__Ldp9N {
  color: #2392fb;
}

.styles_color__VD4ur.styles_ocean-500__EWY6A {
  color: #0074e0;
}

.styles_color__VD4ur.styles_ocean-600__8jCMx {
  color: #043571;
}

.styles_color__VD4ur.styles_space-50__XDhxy {
  color: #f0f0f0;
}

.styles_color__VD4ur.styles_space-100__NsGaq {
  color: #e3e3e3;
}

.styles_color__VD4ur.styles_space-200__gINUy {
  color: #bfbfbf;
}

.styles_color__VD4ur.styles_space-300__lagiA {
  color: gray;
}

.styles_color__VD4ur.styles_space-400__KD8EQ {
  color: #616161;
}

.styles_color__VD4ur.styles_space-500__lPr2x {
  color: #283439;
}

.styles_color__VD4ur.styles_gray-50__8saNL {
  color: #eff3f6;
}

.styles_color__VD4ur.styles_gray-100__4-tzA {
  color: #e6ecef;
}

.styles_color__VD4ur.styles_gray-200__YjPgY {
  color: #cfd8de;
}

.styles_color__VD4ur.styles_gray-300__XIQ7o {
  color: #a8b9c2;
}

.styles_color__VD4ur.styles_gray-400__NL98V {
  color: #7e98a5;
}

.styles_color__VD4ur.styles_gray-500__WmB0k {
  color: #738f9c;
}

.styles_color__VD4ur.styles_green-50__9Lvwl {
  color: #e3fdf6;
}

.styles_color__VD4ur.styles_green-100__th7Q2 {
  color: #c5f6ea;
}

.styles_color__VD4ur.styles_green-200__PQiWU {
  color: #69ddc2;
}

.styles_color__VD4ur.styles_green-300__s-V7\\+ {
  color: #45bfa3;
}

.styles_color__VD4ur.styles_green-400__ellsR {
  color: #1cab8a;
}

.styles_color__VD4ur.styles_green-500__GngGW {
  color: #128268;
}

.styles_color__VD4ur.styles_red-50__N-mI\\+ {
  color: #fff0f3;
}

.styles_color__VD4ur.styles_red-100__lKr0G {
  color: #f9d2db;
}

.styles_color__VD4ur.styles_red-200__JE7r0 {
  color: #f8b4c4;
}

.styles_color__VD4ur.styles_red-300__OJ3qR {
  color: #e85e81;
}

.styles_color__VD4ur.styles_red-400__Xviay {
  color: #e23661;
}

.styles_color__VD4ur.styles_red-500__bQJBW {
  color: #b82348;
}

.styles_color__VD4ur.styles_yellow-50__ZsbAe {
  color: #fffae6;
}

.styles_color__VD4ur.styles_yellow-100__VmRjA {
  color: #fff0b3;
}

.styles_color__VD4ur.styles_yellow-200__0bbKu {
  color: #ffe380;
}

.styles_color__VD4ur.styles_yellow-300__NVVfN {
  color: #ffcf57;
}

.styles_color__VD4ur.styles_yellow-400__gmkjj {
  color: #ffc60a;
}

.styles_color__VD4ur.styles_yellow-500__PjQKs {
  color: #ffb700;
}

.styles_color__VD4ur.styles_orange-50__L29IS {
  color: #fff2eb;
}

.styles_color__VD4ur.styles_orange-100__56PWG {
  color: #ffe4d6;
}

.styles_color__VD4ur.styles_orange-200__0aDG3 {
  color: #ffc69e;
}

.styles_color__VD4ur.styles_orange-300__y2XE5 {
  color: #ffa047;
}

.styles_color__VD4ur.styles_orange-400__TpRzq {
  color: #ff7b42;
}

.styles_color__VD4ur.styles_orange-500__0qlXC {
  color: #ee4920;
}

.styles_color__VD4ur.styles_turquoise-50__HIMEX {
  color: transparent;
}

.styles_color__VD4ur.styles_turquoise-100__uy0xH {
  color: #e6fcff;
}

.styles_color__VD4ur.styles_turquoise-200__T3-SM {
  color: #b3f5ff;
}

.styles_color__VD4ur.styles_turquoise-300__F3guv {
  color: #78e2f2;
}

.styles_color__VD4ur.styles_turquoise-400__uftFe {
  color: #00c7e6;
}

.styles_color__VD4ur.styles_turquoise-500__VcFYI {
  color: transparent;
}

.styles_color__VD4ur.styles_turquoise-600__AznRj {
  color: transparent;
}

.styles_color__VD4ur.styles_violet-50__4Ji6R {
  color: #eae6ff;
}

.styles_color__VD4ur.styles_violet-100__CCR47 {
  color: #d9d1ff;
}

.styles_color__VD4ur.styles_violet-200__kxrSq {
  color: #bfb3ff;
}

.styles_color__VD4ur.styles_violet-300__anl4p {
  color: #9d90ea;
}

.styles_color__VD4ur.styles_violet-400__tv6\\+z {
  color: #8678d9;
}

.styles_color__VD4ur.styles_violet-500__v-jp6 {
  color: #6f5ccc;
}

.styles_color__VD4ur.styles_snow-50__yK\\+gU {
  color: white;
}

.styles_color__VD4ur.styles_snow-100__msrfP {
  color: #f7f7f7;
}

.styles_color__VD4ur.styles_snow-200__OW-EP {
  color: #f0efef;
}

.styles_color__VD4ur.styles_snow-300__niGIZ {
  color: #e6e6e6;
}

.styles_color__VD4ur.styles_snow-400__achLM {
  color: #e1e0e0;
}

.styles_color__VD4ur.styles_snow-500__gpBni {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__vw1TD.styles_ocean__x8Vb2 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__vw1TD.styles_ocean-light__HejBh {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__vw1TD.styles_green__D3c\\+x {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__vw1TD.styles_green-light__mrym6 {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__vw1TD.styles_red__5z3eE {
  background-color: #e23661;
  color: white;
}

.styles_background-color__vw1TD.styles_red-light__zJs2E {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__vw1TD.styles_orange__IZjK7 {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__vw1TD.styles_orange-light__3o4zG {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__vw1TD.styles_space__VNSyo {
  background-color: #616161;
  color: white;
}

.styles_background-color__vw1TD.styles_space-light__o0Xv3 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__vw1TD.styles_gray-light__Ii6qe {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__vw1TD.styles_violet__ttK43 {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__vw1TD.styles_violet-light__iVqEE {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__vw1TD.styles_yellow__x5Pn6 {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__vw1TD.styles_yellow-light__z-p9L {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__0-hZ2 {
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.styles_root__0-hZ2 .styles_badge__lJNbN {
  font-weight: 500;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  align-items: center;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  min-height: 20px;
  min-width: 20px;
  padding: 0px 4px ;
  position: absolute;
}
.styles_root__0-hZ2.styles_standAlone__PlyoP {
  align-items: flex-start;
  display: inline-flex;
  justify-content: flex-start;
}
.styles_root__0-hZ2.styles_standAlone__PlyoP .styles_badge__lJNbN {
  position: static;
  right: 0;
  top: 0;
  transform: none;
}
.styles_root__0-hZ2 .styles_dot__s-gnv {
  border-radius: 50%;
  box-sizing: content-box;
  min-height: 10px;
  min-width: 10px;
  padding: 0px ;
}
.styles_root__0-hZ2 .styles_dot__s-gnv.styles_border__KaWEB {
  border: 2px solid white;
}
.styles_root__0-hZ2 .styles_top__gZ\\+Pd {
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
}
.styles_root__0-hZ2 .styles_bottom__bDYHz {
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
}
.styles_root__0-hZ2 .styles_right__isB-p {
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
}
.styles_root__0-hZ2 .styles_left__z9zHO {
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
}
.styles_root__0-hZ2 .styles_topRight__76Cf9 {
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
}
.styles_root__0-hZ2 .styles_topLeft__0cPvv {
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
}
.styles_root__0-hZ2 .styles_bottomLeft__EBfR3 {
  bottom: 0;
  left: 0;
  transform: translate(-50%, 50%);
}
.styles_root__0-hZ2 .styles_bottomRight__X4FVB {
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%);
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/badge/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;AA0UJ;AAxUI;EE6CA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFKjB,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA6UR;AA1UI;EACI,uBAAA;EACA,oBAAA;EACA,2BAAA;AA4UR;AA1UQ;EACI,gBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;AA4UZ;AAxUI;EACI,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AA0UR;AAxUQ;EACI,uBAAA;AA0UZ;AAtUI;EACI,SAAA;EACA,MAAA;EACA,gCAAA;AAwUR;AArUI;EACI,SAAA;EACA,SAAA;EACA,+BAAA;AAuUR;AApUI;EACI,QAAA;EACA,QAAA;EACA,+BAAA;AAsUR;AAnUI;EACI,OAAA;EACA,QAAA;EACA,gCAAA;AAqUR;AAlUI;EACI,QAAA;EACA,MAAA;EACA,+BAAA;AAoUR;AAjUI;EACI,OAAA;EACA,MAAA;EACA,gCAAA;AAmUR;AAhUI;EACI,SAAA;EACA,OAAA;EACA,+BAAA;AAkUR;AA/TI;EACI,SAAA;EACA,QAAA;EACA,8BAAA;AAiUR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n\n    .badge {\n        @include theme.typo(info2);\n\n        align-items: center;\n        border-radius: theme.get-border-radius(xl);\n        display: flex;\n        justify-content: center;\n        min-height: 20px;\n        min-width: 20px;\n        padding: theme.spacing(0, 0.5);\n        position: absolute;\n    }\n\n    &.standAlone {\n        align-items: flex-start;\n        display: inline-flex;\n        justify-content: flex-start;\n\n        .badge {\n            position: static;\n            right: 0;\n            top: 0;\n            transform: none;\n        }\n    }\n\n    .dot {\n        border-radius: theme.get-border-radius(rounded);\n        box-sizing: content-box;\n        min-height: 10px;\n        min-width: 10px;\n        padding: theme.spacing(0);\n\n        &.border {\n            border: 2px solid theme.color(snow-50);\n        }\n    }\n\n    .top {\n        left: 50%;\n        top: 0;\n        transform: translate(-50%, -50%);\n    }\n\n    .bottom {\n        bottom: 0;\n        left: 50%;\n        transform: translate(-50%, 50%);\n    }\n\n    .right {\n        right: 0;\n        top: 50%;\n        transform: translate(50%, -50%);\n    }\n\n    .left {\n        left: 0;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    .topRight {\n        right: 0;\n        top: 0;\n        transform: translate(50%, -50%);\n    }\n\n    .topLeft {\n        left: 0;\n        top: 0;\n        transform: translate(-50%, -50%);\n    }\n\n    .bottomLeft {\n        bottom: 0;\n        left: 0;\n        transform: translate(-50%, 50%);\n    }\n\n    .bottomRight {\n        bottom: 0;\n        right: 0;\n        transform: translate(50%, 50%);\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__VD4ur`,
	"ocean-50": `styles_ocean-50__sdxbh`,
	"ocean-100": `styles_ocean-100__9SceT`,
	"ocean-200": `styles_ocean-200__5QgkQ`,
	"ocean-300": `styles_ocean-300__RuOh3`,
	"ocean-400": `styles_ocean-400__Ldp9N`,
	"ocean-500": `styles_ocean-500__EWY6A`,
	"ocean-600": `styles_ocean-600__8jCMx`,
	"space-50": `styles_space-50__XDhxy`,
	"space-100": `styles_space-100__NsGaq`,
	"space-200": `styles_space-200__gINUy`,
	"space-300": `styles_space-300__lagiA`,
	"space-400": `styles_space-400__KD8EQ`,
	"space-500": `styles_space-500__lPr2x`,
	"gray-50": `styles_gray-50__8saNL`,
	"gray-100": `styles_gray-100__4-tzA`,
	"gray-200": `styles_gray-200__YjPgY`,
	"gray-300": `styles_gray-300__XIQ7o`,
	"gray-400": `styles_gray-400__NL98V`,
	"gray-500": `styles_gray-500__WmB0k`,
	"green-50": `styles_green-50__9Lvwl`,
	"green-100": `styles_green-100__th7Q2`,
	"green-200": `styles_green-200__PQiWU`,
	"green-300": `styles_green-300__s-V7+`,
	"green-400": `styles_green-400__ellsR`,
	"green-500": `styles_green-500__GngGW`,
	"red-50": `styles_red-50__N-mI+`,
	"red-100": `styles_red-100__lKr0G`,
	"red-200": `styles_red-200__JE7r0`,
	"red-300": `styles_red-300__OJ3qR`,
	"red-400": `styles_red-400__Xviay`,
	"red-500": `styles_red-500__bQJBW`,
	"yellow-50": `styles_yellow-50__ZsbAe`,
	"yellow-100": `styles_yellow-100__VmRjA`,
	"yellow-200": `styles_yellow-200__0bbKu`,
	"yellow-300": `styles_yellow-300__NVVfN`,
	"yellow-400": `styles_yellow-400__gmkjj`,
	"yellow-500": `styles_yellow-500__PjQKs`,
	"orange-50": `styles_orange-50__L29IS`,
	"orange-100": `styles_orange-100__56PWG`,
	"orange-200": `styles_orange-200__0aDG3`,
	"orange-300": `styles_orange-300__y2XE5`,
	"orange-400": `styles_orange-400__TpRzq`,
	"orange-500": `styles_orange-500__0qlXC`,
	"turquoise-50": `styles_turquoise-50__HIMEX`,
	"turquoise-100": `styles_turquoise-100__uy0xH`,
	"turquoise-200": `styles_turquoise-200__T3-SM`,
	"turquoise-300": `styles_turquoise-300__F3guv`,
	"turquoise-400": `styles_turquoise-400__uftFe`,
	"turquoise-500": `styles_turquoise-500__VcFYI`,
	"turquoise-600": `styles_turquoise-600__AznRj`,
	"violet-50": `styles_violet-50__4Ji6R`,
	"violet-100": `styles_violet-100__CCR47`,
	"violet-200": `styles_violet-200__kxrSq`,
	"violet-300": `styles_violet-300__anl4p`,
	"violet-400": `styles_violet-400__tv6+z`,
	"violet-500": `styles_violet-500__v-jp6`,
	"snow-50": `styles_snow-50__yK+gU`,
	"snow-100": `styles_snow-100__msrfP`,
	"snow-200": `styles_snow-200__OW-EP`,
	"snow-300": `styles_snow-300__niGIZ`,
	"snow-400": `styles_snow-400__achLM`,
	"snow-500": `styles_snow-500__gpBni`,
	"background-color": `styles_background-color__vw1TD`,
	"ocean": `styles_ocean__x8Vb2`,
	"ocean-light": `styles_ocean-light__HejBh`,
	"green": `styles_green__D3c+x`,
	"green-light": `styles_green-light__mrym6`,
	"red": `styles_red__5z3eE`,
	"red-light": `styles_red-light__zJs2E`,
	"orange": `styles_orange__IZjK7`,
	"orange-light": `styles_orange-light__3o4zG`,
	"space": `styles_space__VNSyo`,
	"space-light": `styles_space-light__o0Xv3`,
	"gray-light": `styles_gray-light__Ii6qe`,
	"violet": `styles_violet__ttK43`,
	"violet-light": `styles_violet-light__iVqEE`,
	"yellow": `styles_yellow__x5Pn6`,
	"yellow-light": `styles_yellow-light__z-p9L`,
	"root": `styles_root__0-hZ2`,
	"badge": `styles_badge__lJNbN`,
	"standAlone": `styles_standAlone__PlyoP`,
	"dot": `styles_dot__s-gnv`,
	"border": `styles_border__KaWEB`,
	"top": `styles_top__gZ+Pd`,
	"bottom": `styles_bottom__bDYHz`,
	"right": `styles_right__isB-p`,
	"left": `styles_left__z9zHO`,
	"topRight": `styles_topRight__76Cf9`,
	"topLeft": `styles_topLeft__0cPvv`,
	"bottomLeft": `styles_bottomLeft__EBfR3`,
	"bottomRight": `styles_bottomRight__X4FVB`
};
export default ___CSS_LOADER_EXPORT___;
